import angular from 'angular';
import template from './search-field.html';
import './search-field.scss';
class SearchFieldController {
    constructor() { }
    $onInit() { }
    $onChanges(changes) {
        if (changes.searchModel) {
            this.searchString = this.searchModel;
        }
    }
}
const searchField = {
    template,
    bindings: {
        searchModel: '<',
        placeholderText: '@',
        modelOptions: '<?',
        onSearch: '&',
        onClear: '&',
    },
    controller: SearchFieldController,
};
export default angular
    .module('doxy.common.components.searchField', [])
    // search-field
    .component('searchField', searchField).name;
